/**
 * @format
 */
import { NgModule, ModuleWithProviders } from "@angular/core";
import { NgEditorComponent } from "./ng-editor.component";
import { DropdownModule } from "primeng/dropdown";
import { FormsModule } from "@angular/forms";
import { EditorService } from "./services/editor.service";
import { CommonModule } from "@angular/common";
import { TooltipModule } from "ngx-bootstrap/tooltip";
import { NG_EDITOR_CONF } from "./tokens/ng-editor-config.token";
import { StoreModule } from "@ngrx/store";
import { EditorTemplateReducer, STORE_FEATURE_KEY_EDITOR_TEMPLATE } from "./state/editor.reducer";
import { EditorSelectors } from "./state/editor.selectors";
import { EditorActions } from "./state/editor.actions";
import { StylesService } from "./services/styles.service";
import { LinkModalComponent } from "./components/link/link-modal.component";
import { AlignmentToolService } from "./services/alignment-tool.service";
import { UnderlineToolService } from "./services/underline-tool.service";
import { FeatureFlagsModule } from "../feature-flag/feature-flag.module";
import { FontToolService } from "./services/font-tool.service";
import { BoldToolService } from "./services/bold-tool.service";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { ColorPickerModule } from "primeng/colorpicker";
import { FontColorButtonComponent } from "./components/font-color-button/font-color-button.component";

@NgModule({
   declarations: [NgEditorComponent, LinkModalComponent, FontColorButtonComponent],
   imports: [
      FormsModule,
      DropdownModule,
      CommonModule,
      TooltipModule,
      StoreModule.forFeature(STORE_FEATURE_KEY_EDITOR_TEMPLATE, EditorTemplateReducer),
      FeatureFlagsModule,
      OverlayPanelModule,
      ColorPickerModule,
   ],
   exports: [NgEditorComponent],
   providers: [
      EditorActions,
      EditorSelectors,
      EditorService,
      StylesService,
      AlignmentToolService,
      BoldToolService,
      UnderlineToolService,
      FontToolService,
      {
         provide: NG_EDITOR_CONF,
         useValue: {
            placeholder: "",
            tabsize: 2,
            height: "500px",
            uploadImagePath: "/api/upload",
            toolbar: [
               ["misc", ["codeview", "undo", "redo"]],
               ["style", ["bold", "italic", "underline", "clear"]],
               ["font", ["strikethrough", "superscript", "subscript", "clear"]],
               ["fontsize", ["fontname", "fontsize", "color"]],
               ["para", ["style", "ul", "ol", "paragraph", "height"]],
               ["insert", ["link"]],
            ],
            fontNames: ["Helvetica", "Arial", "Arial Black", "Comic Sans MS", "Courier New", "Roboto", "Times"],
         },
      },
   ],
})
export class NgEditorModule {
   public static forRoot(): ModuleWithProviders<NgEditorModule> {
      return {
         ngModule: NgEditorModule,
         providers: [],
      };
   }
}
